jQuery(function () {
	jQuery(window)
		.bind("resize", function () {
			if (jQuery(window).width() < 740) {
				jQuery(".js-carousel").removeClass("grid");
			} else {
				jQuery(".js-carousel").addClass("grid");
			}
		})
		.resize();
});
